var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    {
      staticClass: "header-nav",
      class: { "header-nav--two-row": _vm.twoRow },
      attrs: { fluid: "" },
    },
    [
      _c(
        "v-container",
        { staticClass: "header-nav__bar" },
        [
          _c(
            "v-row",
            [
              _c(
                "v-col",
                { staticClass: "header-nav__logo", attrs: { cols: "auto" } },
                [
                  _c(
                    "router-link",
                    {
                      staticClass: "hn-logo",
                      attrs: {
                        to: _vm.currentUserShopSlug
                          ? "/" + _vm.currentUserShopSlug
                          : { name: "Home" },
                      },
                    },
                    [
                      _vm.currentCategoryImage
                        ? [
                            _c("img", {
                              staticClass: "hn-logo__category",
                              attrs: {
                                src: _vm.currentCategoryImage,
                                alt: _vm.currentCategoryName,
                              },
                            }),
                          ]
                        : _vm.shopLogo
                        ? [
                            _c("img", {
                              staticClass: "hn-logo__shop",
                              attrs: { src: _vm.shopLogo, alt: _vm.appName },
                            }),
                          ]
                        : [
                            _c("img", {
                              staticClass: "hn-logo__bi",
                              attrs: {
                                src: "/assets/img/header/header-bi.svg",
                                alt: _vm.appName,
                              },
                            }),
                            _vm._v(" "),
                            _c("img", {
                              staticClass: "hn-logo__default",
                              attrs: {
                                src: "/assets/img/header/header-logo.svg",
                                alt: _vm.appName,
                              },
                            }),
                          ],
                    ],
                    2
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c("v-col", { staticClass: "header-nav__left" }, [
                _vm.shopUseHamburgerMenu
                  ? _c(
                      "button",
                      {
                        staticClass: "header-nav__hamburger",
                        class: { "is-active": _vm.flags.isServiceNavOpen },
                        on: { click: _vm.toggleServiceNav },
                      },
                      [
                        _c("i", {
                          staticClass: "las fs-29",
                          class: _vm.flags.isServiceNavOpen
                            ? "la-times"
                            : "la-bars",
                        }),
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.shopUseTopMenu
                  ? _c("nav", { staticClass: "gnb" }, [
                      _c(
                        "ul",
                        { staticClass: "gnb__list" },
                        _vm._l(_vm.menus, function (menu, mIndex) {
                          return _c(
                            "li",
                            {
                              key: mIndex,
                              staticClass: "gnb__item",
                              on: {
                                mouseenter: function ($event) {
                                  return _vm.openDropdown(mIndex)
                                },
                                mouseleave: function ($event) {
                                  return _vm.closeDropdown(mIndex)
                                },
                              },
                            },
                            [
                              _c(
                                "router-link",
                                {
                                  staticClass: "gnb__link",
                                  class: {
                                    "is-active":
                                      _vm.states.hoveredMenuIndex === mIndex ||
                                      _vm.isRouteActive(menu.GROUP.LINK),
                                  },
                                  attrs: { to: menu.GROUP.LINK || "#" },
                                },
                                [
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        menu.GROUP.SHORTNAME || menu.GROUP.NAME
                                      )
                                    ),
                                  ]),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "v-container",
                                {
                                  staticClass: "gnb__mega",
                                  class: {
                                    "is-open":
                                      _vm.states.hoveredMenuIndex === mIndex,
                                  },
                                  attrs: { fluid: "" },
                                },
                                [
                                  _c(
                                    "v-container",
                                    { staticClass: "gnb__mega-inner" },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "gnb__sections" },
                                        _vm._l(
                                          menu.SECTIONS,
                                          function (sectionData, sIndex) {
                                            return _c(
                                              "div",
                                              {
                                                key: sIndex,
                                                staticClass: "gnb__section",
                                              },
                                              [
                                                _c(
                                                  "h3",
                                                  {
                                                    staticClass:
                                                      "gnb__section-title",
                                                  },
                                                  [
                                                    _c("span", [
                                                      _vm._v(
                                                        _vm._s(
                                                          sectionData.SECTION
                                                            .NAME
                                                        )
                                                      ),
                                                    ]),
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "div",
                                                  { staticClass: "gnb__tabs" },
                                                  _vm._l(
                                                    sectionData.TABS,
                                                    function (tab, tIndex) {
                                                      return _c(
                                                        "div",
                                                        {
                                                          key: tIndex,
                                                          staticClass:
                                                            "gnb__tab",
                                                        },
                                                        [
                                                          tab.TYPE === "tab"
                                                            ? _c(
                                                                "h4",
                                                                {
                                                                  staticClass:
                                                                    "gnb__tab-title",
                                                                },
                                                                [
                                                                  _c("span", [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        tab.NAME
                                                                      )
                                                                    ),
                                                                  ]),
                                                                ]
                                                              )
                                                            : _vm._e(),
                                                          _vm._v(" "),
                                                          _c(
                                                            "ul",
                                                            {
                                                              staticClass:
                                                                "gnb__items",
                                                            },
                                                            _vm._l(
                                                              tab.ITEMS,
                                                              function (
                                                                item,
                                                                iIndex
                                                              ) {
                                                                return _c(
                                                                  "li",
                                                                  {
                                                                    key: iIndex,
                                                                    staticClass:
                                                                      "gnb__sub-item",
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "router-link",
                                                                      {
                                                                        attrs: {
                                                                          to: item.LINK,
                                                                        },
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          _vm._s(
                                                                            item.NAME
                                                                          )
                                                                        ),
                                                                      ]
                                                                    ),
                                                                  ],
                                                                  1
                                                                )
                                                              }
                                                            ),
                                                            0
                                                          ),
                                                        ]
                                                      )
                                                    }
                                                  ),
                                                  0
                                                ),
                                              ]
                                            )
                                          }
                                        ),
                                        0
                                      ),
                                      _vm._v(" "),
                                      _c("div", { staticClass: "gnb__brand" }, [
                                        _c("div", {
                                          staticClass: "gnb__promo-placeholder",
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "gnb__brand-footer" },
                                          [
                                            _c(
                                              "p",
                                              {
                                                staticClass: "gnb__brand-text",
                                              },
                                              [
                                                _c("span", [
                                                  _vm._v(
                                                    "환경친화적 인쇄를 지향하는"
                                                  ),
                                                ]),
                                                _vm._v(" "),
                                                _c("br"),
                                                _vm._v(" "),
                                                _c("span", [
                                                  _vm._v("인쇄 넘버원,"),
                                                ]),
                                                _vm._v(" "),
                                                _c("b", [_vm._v("프리원!")]),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c("img", {
                                              staticClass: "gnb__brand-logo",
                                              attrs: {
                                                src: "/assets/img/soyinkmark.svg",
                                                alt: "인증마크",
                                              },
                                            }),
                                          ]
                                        ),
                                      ]),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        }),
                        0
                      ),
                    ])
                  : _vm._e(),
              ]),
              _vm._v(" "),
              _c(
                "v-col",
                { staticClass: "header-nav__right" },
                [
                  _vm._l(
                    _vm.$optional("data.logobar_menu?.labels"),
                    function (menuLabel, i) {
                      return _c(
                        "div",
                        { key: i, staticClass: "header-nav__icon" },
                        [
                          _c(
                            "v-tooltip",
                            {
                              attrs: {
                                attach: "",
                                bottom: "",
                                transition: "slide-y-transition",
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "activator",
                                    fn: function ({ on, attrs }) {
                                      return [
                                        _c(
                                          "router-link",
                                          {
                                            staticClass:
                                              "text-reset d-block pa-2 mx-1",
                                            attrs: {
                                              to:
                                                !_vm.isAuthenticated &&
                                                _vm.shopSlug
                                                  ? _vm.loginLink
                                                  : _vm.$optional(
                                                      "data.logobar_menu.links"
                                                    )[i],
                                            },
                                          },
                                          [
                                            _c(
                                              "i",
                                              _vm._g(
                                                _vm._b(
                                                  {
                                                    staticClass:
                                                      "las fs-30 position-relative",
                                                    class: _vm.$optional(
                                                      "data.logobar_menu.icons"
                                                    )[i],
                                                  },
                                                  "i",
                                                  attrs,
                                                  false
                                                ),
                                                on
                                              ),
                                              [
                                                _vm.getCartCount > 0 &&
                                                _vm.$optional(
                                                  "data.logobar_menu.links"
                                                )[i] === "/cart"
                                                  ? _c("v-badge", {
                                                      staticClass:
                                                        "header-nav__badge",
                                                      attrs: {
                                                        color: "error",
                                                        content:
                                                          _vm.getCartCount,
                                                        inline: "",
                                                      },
                                                    })
                                                  : _vm._e(),
                                              ],
                                              1
                                            ),
                                          ]
                                        ),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                true
                              ),
                            },
                            [
                              _vm._v(" "),
                              _c("span", [_vm._v(_vm._s(menuLabel))]),
                            ]
                          ),
                        ],
                        1
                      )
                    }
                  ),
                  _vm._v(" "),
                  !_vm.isAuthenticated
                    ? _c(
                        "div",
                        { staticClass: "header-nav__icon" },
                        [
                          _c(
                            "v-tooltip",
                            {
                              attrs: {
                                attach: "",
                                bottom: "",
                                transition: "slide-y-transition",
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "activator",
                                    fn: function ({ on, attrs }) {
                                      return [
                                        _c(
                                          "router-link",
                                          {
                                            staticClass:
                                              "text-reset d-block pa-2 mx-1",
                                            attrs: { to: _vm.loginLink },
                                          },
                                          [
                                            _c(
                                              "i",
                                              _vm._g(
                                                _vm._b(
                                                  {
                                                    staticClass:
                                                      "las la-sign-in-alt fs-30",
                                                  },
                                                  "i",
                                                  attrs,
                                                  false
                                                ),
                                                on
                                              )
                                            ),
                                          ]
                                        ),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                false,
                                1190573886
                              ),
                            },
                            [_vm._v(" "), _c("span", [_vm._v("로그인")])]
                          ),
                        ],
                        1
                      )
                    : _c(
                        "div",
                        { staticClass: "header-nav__icon" },
                        [
                          _c(
                            "v-tooltip",
                            {
                              attrs: {
                                attach: "",
                                bottom: "",
                                transition: "slide-y-transition",
                              },
                              scopedSlots: _vm._u([
                                {
                                  key: "activator",
                                  fn: function ({ on, attrs }) {
                                    return [
                                      _c(
                                        "router-link",
                                        {
                                          staticClass:
                                            "text-reset d-block pa-2 mx-1",
                                          attrs: { to: { name: "Logout" } },
                                        },
                                        [
                                          _c(
                                            "i",
                                            _vm._g(
                                              _vm._b(
                                                {
                                                  staticClass:
                                                    "las la-sign-out-alt fs-30",
                                                },
                                                "i",
                                                attrs,
                                                false
                                              ),
                                              on
                                            )
                                          ),
                                        ]
                                      ),
                                    ]
                                  },
                                },
                              ]),
                            },
                            [_vm._v(" "), _c("span", [_vm._v("로그아웃")])]
                          ),
                        ],
                        1
                      ),
                ],
                2
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _vm.shopUseHamburgerMenu
        ? _c("ServiceNavs", {
            attrs: { show: _vm.flags.isServiceNavOpen },
            on: {
              close: function ($event) {
                _vm.flags.isServiceNavOpen = false
              },
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }